"use client"

import { Badge } from "@/components/Primitives/Badge"
import { Label } from "@/components/Primitives/Label"
import { cn } from "@/lib/utils/utils"

interface EstimateWithLabelProps {
  time: string | null
  label: string
  badgeTextColor: string
  badgeBackgroundColor: string
  className?: string
}

export function EstimateWithLabel({
  time,
  label,
  badgeTextColor,
  badgeBackgroundColor,
  className,
}: EstimateWithLabelProps) {
  if (!time) {
    return null
  }

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <Label className="text-xs text-slate-500">{label}</Label>
      <Badge
        className={cn(
          "text-xs font-semibold",
          badgeTextColor,
          badgeBackgroundColor,
        )}
      >
        {time}
      </Badge>
    </div>
  )
}
